import { ControlResponse } from "@/main/models/response/controlResponse";

export enum ControlTypes {
	GET_CONTROLS_BY_SCREEN = "@control/GET_CONTROLS_BY_SCREEN",
	SAVE_CONTROLS_BY_SCREEN = "@control/SAVE_CONTROLS_BY_SCREEN",
	RESET_REDUCER_CONTROLS_BY_SCREEN = "@control/RESET_REDUCER_CONTROLS_BY_SCREEN",
}

export interface ControlState {
	readonly controlsByScreen: {
		data: ControlResponse[] | null;
		errorMessages: string[] | null;
		isError: boolean;
		isLoading: boolean;
	};
}

export interface GetControlsByScreen {
	type: typeof ControlTypes.GET_CONTROLS_BY_SCREEN;
	payload: { guidScreen: string };
}

export interface SaveControlsByScreen {
	type: typeof ControlTypes.SAVE_CONTROLS_BY_SCREEN;
	payload: {
		data: ControlResponse[] | null;
		isError: boolean;
		errorMessages: string[] | null;
	};
}

export interface ResetReducerControlsByScreen {
	type: typeof ControlTypes.RESET_REDUCER_CONTROLS_BY_SCREEN;
}

export type ControlActionTypes = GetControlsByScreen | SaveControlsByScreen | ResetReducerControlsByScreen;
